//Componentes generales
import React, { useState, useContext } from "react";
import { FixedSizeList } from "react-window";
import SearchInput from "../searchInput/SearchInput";
import RenderRow from "../renderRows/RRDistribuciones";
import windowSizeContext from "../../context/windowSize/windowSizeContext";

//Estilos
import "./DistribucionList.css";

/*
    Componente encargado de la vista de las distribuciones disponibles.
    Donde distribuciones es la lista de distribuciones disponibles recuperados del context.
*/
function DistribucionList({ distribuciones = [] }) {
  //state de filtro.
  const [filter, setFilter] = useState("");

  // Calcula el valor del height según el tamaño de la pantalla y el tamaño del navbar
  const wSContext = useContext(windowSizeContext);
  let { height } = wSContext;

  /*
    Manejador ante cambios en filtro.
    Donde data es el texto ingresado por el usuario.
    */
  const handdlerSearchInput = (data) => {
    setFilter(data);
  };

  return (
    <div>
      <div style={{ marginLeft: "-350px" }}>
        <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
      </div>
      <div className="container-distribucion-list">

        <FixedSizeList
          height={height - 270}
          itemCount={
            filter === ""
              ? distribuciones.length
              : distribuciones.filter(
                (d) =>
                  d.codDim.toLowerCase().includes(filter.toLowerCase()) ||
                  d.codDimDescrp.toLowerCase().includes(filter.toLowerCase()) ||
                  d.codDis.toLowerCase().includes(filter.toLowerCase()) ||
                  d.codDisDescrp.toLowerCase().includes(filter.toLowerCase())
              ).length
          }
          itemSize={110}
          width={"100%"}
        >
          {({ index, style }) => (
            <RenderRow
              index={index}
              style={style}
              distribuciones={distribuciones}
              filter={filter}
            />
          )}
        </FixedSizeList>
      </div>
    </div>
  );
}

export default DistribucionList;
